import { render, staticRenderFns } from "./cartHalbkreis.vue?vue&type=template&id=2963448d&"
import script from "./cartHalbkreis.vue?vue&type=script&lang=js&"
export * from "./cartHalbkreis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports